import { ExportToXlsxWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ExportToXlsx')
export class ExportToXlsxConnectorProvider extends ConnectorProvider<ExportToXlsxWorkflowNode> {}
